// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productSummaryStyles } from "@conklin/App/Widgets/ProductDetails/ProductDetailsSummary";
import { fontConfig } from "@conklin/XDL/PreStyle/typography";
import { css } from "styled-components";

productSummaryStyles.productSummary = {
    variant: "h6",
    weight: fontConfig.weight.regular,
    css: css`
        line-height: 22px;
        &:empty {
            margin: 0;
        }
    `,
};
